// Externally-visible signature
import axiosLib from "axios";

export function unreachable(p: never): never;
// Implementation signature
export function unreachable() {
  throw new Error("Switch is not exhaustive");
}

export type QueryStatus = "idle" | "processing" | "success" | "failed";

export const authAxios = (payload: {
  companyUuid?: string | undefined;
  departmentUuid?: string | undefined;
}) => {
  const baseUrl = `${import.meta.env["VITE_BACKEND_URL"] as string}/office/`;
  return axiosLib.create({
    baseURL: baseUrl,
    timeout: 120000,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token") as string}`,
      "x-company-uuid": payload.companyUuid ?? "",
      "x-department-uuid": payload.departmentUuid ?? "",
    },
  });
};

export const axiosInstanceNoAuth = () =>
  axiosLib.create({
    baseURL: `${import.meta.env["VITE_BACKEND_URL"] as string}/office`,
    timeout: 10000,
    headers: { Authorization: `Bearer` },
  });
